<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择商务申请"
      width="1200px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="sd/ba/priceWithPage"
        @select="salesOrderSelect"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="关键字" prop="keyWords">
            <el-input v-model.trim="filter.keyWords" placeholder="请输入关键字查询" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          customerId: "",
          keyWords: "",
        },
        columns: [
          {
            title: "商务编号",
            key: "businessApplicationNO",
            width: 120,
            align: "center",
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 180,
          },
          {
            title: "物料名称",
            key: "materialName",
          },
          {
            title: "规格型号",
            key: "specification",
            width: 180,
          },
          {
            title: "审批价格",
            key: "approve3Price",
            width: 100,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(customerId) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.filter.customerId = customerId;
          this.$refs.tableSelect.loadData();
        });
      },

      salesOrderSelect(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
